export default __webpack_public_path__ + "static/media/brand-dots.f17f011e.svg";